export default __webpack_public_path__ + "static/funders-sbu-1e7ffea2304f358a9997d56c9c3919ff.png";